import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import Select from 'react-select';
import clsx from 'clsx';

const JurisdictionOption = ({ innerRef, innerProps, ...rest }) => {
    const { data, isSelected } = rest;

    return (
        <div className={clsx('d-flex flex-column px-3 py-1 juridistion-select--option text-dark', isSelected && 'active')} ref={innerRef} {...innerProps}>
            <div className="align-items-center">
                {/* <img className="signature-icon" src={`/images/listing/${data.value}.png`} style={{width: 30}} alt={data.description} /> */}
                <strong >{data.label}</strong>
            </div>
            <small>{data.description}</small>
            {/* <components.Option {...props} /> */}
        </div>
    );
  }

export function useJurisdictionList() {
    const { t } = useTranslation();

    const jurisdictionsMap = useMemo(() => {
        return new Map([
            ['mx', { label: t('jurisdictions.mx'), value: 'mx', description: t('jurisdictions.mx') }],
            ['us', { label: t('jurisdictions.us'), value: 'us', description: t('jurisdictions.us') }],
            // ['br', { label: t('jurisdictions.br'), value: 'br', description: t('jurisdictions.br') }],
            ['pr', { label: t('jurisdictions.pr'), value: 'pr', description: t('jurisdictions.pr') }],
            // ['at', { label: t('jurisdictions.at'), value: 'at', description: t('jurisdictions.at') }],
            ['co', { label: t('jurisdictions.co'), value: 'co', description: t('jurisdictions.co') }],
        ])
    }, [t])
    
    return { jurisdictionsMap, jurisdictionsArray: Array.from(jurisdictionsMap.values()) }
}

export function JurisdictionSelect({ value, onChange, ...props }) {
    const [realValue, setRealValue] = useState(null);
    const { jurisdictionsArray, jurisdictionsMap } = useJurisdictionList();
    console.log({value})
    useEffect(() => {
        if (jurisdictionsMap.get(value)) {
            setRealValue(jurisdictionsMap.get(value))
        } else {
            setRealValue(null)
        }
    }, [jurisdictionsMap, value])

    const handleChange = (option) => {
        onChange(option?.value || null, option)
    }

    return <Select 
        components={{ Option:  JurisdictionOption }}
        options={jurisdictionsArray}
        styles={{ menu: base => ({ ...base, zIndex: 1000 }) }}
        value={realValue}
        onChange={handleChange}
        {...props}
    />
}